<template>
    <div>
      <div style="margin-top:30px; margin-left: 20px;">
        <div v-for="t in shouceList" :key="t.name" style="border-bottom: #cccccc 1px solid;">
          <div style="font-size: 18px;font-weight: 700;" v-html="t.name"></div>
          <div style="margin-left: 10px;">
            <template v-for="s in t.datas">
              <el-row :key="s.name">
                <el-col :span="16">
                  <el-link type="primary" size="mini" style="font-size: 16px;margin: 7px;" @click="downloadShouCe(s)"> {{s.name}} </el-link>
                </el-col>
                <el-col :span="5" v-if="s.videoUrl">
                  <el-button type="primary" size="mini" icon="el-icon-video-camera-solid" circle @click="toVideo(s.videoUrl)"></el-button>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import baseUrl, {imageUrl} from "../../constants";
    export default {
        data() {
            return {
              shouceList: [
                {name: "通用部分", datas: [
                    {name: "1 系统使用环境.pdf", url: ""},
                    {name: "2 单位注册.pdf", url: ""},
                    {name: "3 个人注册.pdf", url: ""},
                    {name: "4 用户登录.pdf", url: ""},
                    {name: "5 绑定单位申请.pdf", url: ""},
                    {name: "6 绑定单位审核.pdf", url: ""}]
                },
                {name: "企业部分", datas: [
                    {name: "7 计量器具台账.pdf", url: ""},
                    {name: "8 器具备案申请.pdf", url: ""},
                    {name: "9 器具检定申请.pdf", url: ""}]
                },
                {name: "行政部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                    {name: "10 基础设置（行政）.pdf", url: ""},
                    {name: "11 备案办理.pdf", url: ""}]
                },
                {name: "机构部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                    {name: "12 基础设置（机构）.pdf", url: ""},
                    {name: "13 检定办理.pdf", url: ""}]
                },
                {name: "诚信计量操作手册", datas: [
                    {name: "申报指南.pdf", url: "", videoUrl: '/public/video/%E8%AF%9A%E4%BF%A1%E8%AE%A1%E9%87%8F%E7%94%B3%E8%AF%B7%E5%8D%95%E4%BD%8D%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.mp4'}]
                }
              ]
            }
        },
        methods: {
          downloadShouCe(row){
            if(row.name === '3 强检计量器具台账器具信息填写指南'){
              console.log("123");
            }else{
              window.open(baseUrl + "/file/download?file=/shoucePDF/" + row.name + "&name=" + row.name, '_blank');
            }
          },
          downloadChangJianWenTi(){
            window.open(baseUrl + "/file/download?file=/shoucePDF/常见问题解答（一）.pdf&name=常见问题解答（一）.pdf", '_blank');
          },
          downloadCaoZuoZhiYin(){
            window.open(baseUrl + "/file/download?file=/shoucePDF/计量业务应用平台-诚信计量申请单位用户操作指引.pdf&name=计量业务应用平台-诚信计量申请单位用户操作指引.pdf", '_blank');
          },
          toZhiNengWenDa(){
            window.open("https://www.hebjlzy.com/front/#/intelligentQa/toIntelligentQaIndex", '_blank');
          },
          toVideo(videoUrl){
            window.open(imageUrl + videoUrl);
          }
        }
    }
</script>

<style scoped>

</style>